import React from 'react'

import { Link } from 'react-router-dom'

import { Container, SANS_3, SERIF_5_6, SERIF_9_10, UI_BODY_BOLD, UI_HEADLINE, Wrapper1000 } from 'oolib'
import { useGetQueryData } from '../../utils/react-query-hooks/general'

const OKE401 = ({msg}) => {
  const {
    deployment: {
      _Logos: { logo },
    },
  } = useGetQueryData('platformConfigs')

  return (
     <Container
     style={{ paddingTop: "2rem", paddingBottom: "2rem", textAlign: "center" }}
   >
     <Wrapper1000>
       {<UI_HEADLINE>{"401"}</UI_HEADLINE>}
       <UI_BODY_BOLD>{msg || "Sorry! You do not have access to this content."}</UI_BODY_BOLD>
       {/* <SANS_3 style={{ padding: "4rem 0 2rem 0" }}>
         So I must say, You Shall Not Pass.
       </SANS_3> */}
       <Link to="/">
         <img alt={"OKE401"} src={logo} style={{ width: "150px" }} />
       </Link>
     </Wrapper1000>
   </Container>
  )
}

export default OKE401
